import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";

export default function PushPermissionPrimerDialog({
  open,
  onEnable,
  onClose,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      closeAfterTransition
      keepMounted={false}
      TransitionProps={{ unmountOnExit: true }}
      slotProps={{ backdrop: { sx: { pointerEvents: open ? "auto" : "none" } } }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1.25 }}>
        <Stack spacing={1.25} alignItems="flex-start">
          <Box
            sx={(theme) => ({
              width: 46,
              height: 46,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: alpha(theme.colors.green, 0.16),
              color: theme.colors.green,
            })}
          >
            <NotificationsActiveRoundedIcon />
          </Box>
          <Typography variant="h5" component="span" sx={{ fontWeight: 900, lineHeight: 1.06 }}>
            Don&apos;t miss the drop
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="body1" sx={{ fontWeight: 800 }}>
            Get pinged when something is ready nearby.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Reveals, nearby hints, and replies can reach you even when the app is closed.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Stack spacing={1} sx={{ width: "100%" }}>
          <Button
            variant="contained"
            onClick={onEnable}
            fullWidth
            startIcon={<BoltRoundedIcon />}
            sx={(theme) => ({
              p: "12px 20px",
              fontWeight: 900,
              bgcolor: theme.colors.green,
              color: theme.palette.getContrastText(theme.colors.green),
              "&:hover": {
                bgcolor: theme.colors.green,
              },
              "& .MuiButton-startIcon": {
                color: "inherit",
              },
            })}
          >
            Turn on alerts
          </Button>
          <Button
            variant="text"
            onClick={onClose}
            fullWidth
            sx={{
              fontWeight: 700,
              color: "text.secondary",
            }}
          >
            Maybe later
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
